/**
 * Generated by orval v8.17.0 🍺
 * Do not edit manually.
 * BeLink
 * In the documentation API requests will be sent from currently logged in user so you do not need to provide a bearer token manually. <br><br> When calling API from outside the documentation, you will need to provide an access token for all requests in authorization header: `Authorization: Bearer <Token>` <br> You can create a new access token in your account settings page.
 * OpenAPI spec version: 1.0.0
 */
import type {BulkCreateLinksBody} from './schemas/bulk-create-links-body';

import type {BulkUpdateLinksBody} from './schemas/bulk-update-links-body';

import type {CreateLink200} from './schemas/create-link200';

import type {CreateMultipleLinks200} from './schemas/create-multiple-links200';

import type {CrupdateLinkBody} from './schemas/crupdate-link-body';

import type {DeleteLinksParams} from './schemas/delete-links-params';

import type {ExportLinksCsvBody} from './schemas/export-links-csv-body';

import type {ExportLinksCsv200} from './schemas/export-links-csv200';

import type {GetMetadataFromUrlBody} from './schemas/get-metadata-from-url-body';

import type {GetMetadataFromUrl200} from './schemas/get-metadata-from-url200';

import type {ListLinksParams} from './schemas/list-links-params';

import type {ListLinks200} from './schemas/list-links200';

import type {RetrieveLink200} from './schemas/retrieve-link200';

import type {UpdateLink200} from './schemas/update-link200';

import type {ValidateLinkPasswordBody} from './schemas/validate-link-password-body';

import type {ValidateLinkPassword200} from './schemas/validate-link-password200';

import {orvalApiFetch} from '../../../common/foundation/resources/client/http/query-client';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary List all links
 */
export const listLinks = (
  params?: ListLinksParams,
  options?: SecondParameter<typeof orvalApiFetch<ListLinks200>>,
) => {
  return orvalApiFetch<ListLinks200>(
    {url: `/links`, method: 'GET', params},
    options,
  );
};
/**
 * @summary Create a link
 */
export const createLink = (
  crupdateLinkBody?: CrupdateLinkBody,
  options?: SecondParameter<typeof orvalApiFetch<CreateLink200>>,
) => {
  return orvalApiFetch<CreateLink200>(
    {
      url: `/links`,
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      data: crupdateLinkBody,
    },
    options,
  );
};
/**
 * @summary Retrieve a link
 */
export const retrieveLink = (
  id: number,
  options?: SecondParameter<typeof orvalApiFetch<RetrieveLink200>>,
) => {
  return orvalApiFetch<RetrieveLink200>(
    {url: `/links/${id}`, method: 'GET'},
    options,
  );
};
/**
 * @summary Update a link
 */
export const updateLink = (
  id: number,
  crupdateLinkBody?: CrupdateLinkBody,
  options?: SecondParameter<typeof orvalApiFetch<UpdateLink200>>,
) => {
  return orvalApiFetch<UpdateLink200>(
    {
      url: `/links/${id}`,
      method: 'PUT',
      headers: {'Content-Type': 'application/json'},
      data: crupdateLinkBody,
    },
    options,
  );
};
/**
 * @summary Export links as CSV
 */
export const exportLinksCsv = (
  exportLinksCsvBody: ExportLinksCsvBody,
  options?: SecondParameter<typeof orvalApiFetch<ExportLinksCsv200>>,
) => {
  return orvalApiFetch<ExportLinksCsv200>(
    {
      url: `/links/csv/export`,
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      data: exportLinksCsvBody,
    },
    options,
  );
};
/**
 * @summary Create multiple links
 */
export const createMultipleLinks = (
  bulkCreateLinksBody: BulkCreateLinksBody,
  options?: SecondParameter<typeof orvalApiFetch<CreateMultipleLinks200>>,
) => {
  return orvalApiFetch<CreateMultipleLinks200>(
    {
      url: `/links/bulk`,
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      data: bulkCreateLinksBody,
    },
    options,
  );
};
/**
 * @summary Update multiple links
 */
export const batchUpdateLinks = (
  bulkUpdateLinksBody: BulkUpdateLinksBody,
  options?: SecondParameter<typeof orvalApiFetch<void>>,
) => {
  return orvalApiFetch<void>(
    {
      url: `/links/bulk`,
      method: 'PUT',
      headers: {'Content-Type': 'application/json'},
      data: bulkUpdateLinksBody,
    },
    options,
  );
};
/**
 * @summary Delete multiple links
 */
export const deleteLinks = (
  params: DeleteLinksParams,
  options?: SecondParameter<typeof orvalApiFetch<void>>,
) => {
  return orvalApiFetch<void>(
    {url: `/links/bulk`, method: 'DELETE', params},
    options,
  );
};
/**
 * Check if given password for link is valid.
 * @summary Validate link password
 */
export const validateLinkPassword = (
  validateLinkPasswordBody: ValidateLinkPasswordBody,
  options?: SecondParameter<typeof orvalApiFetch<ValidateLinkPassword200>>,
) => {
  return orvalApiFetch<ValidateLinkPassword200>(
    {
      url: `/links/check-password`,
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      data: validateLinkPasswordBody,
    },
    options,
  );
};
/**
 * @summary Get metadata from URL
 */
export const getMetadataFromUrl = (
  getMetadataFromUrlBody: GetMetadataFromUrlBody,
  options?: SecondParameter<typeof orvalApiFetch<GetMetadataFromUrl200>>,
) => {
  return orvalApiFetch<GetMetadataFromUrl200>(
    {
      url: `/links/meta`,
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      data: getMetadataFromUrlBody,
    },
    options,
  );
};
export type ListLinksResult = NonNullable<
  Awaited<ReturnType<typeof listLinks>>
>;
export type CreateLinkResult = NonNullable<
  Awaited<ReturnType<typeof createLink>>
>;
export type RetrieveLinkResult = NonNullable<
  Awaited<ReturnType<typeof retrieveLink>>
>;
export type UpdateLinkResult = NonNullable<
  Awaited<ReturnType<typeof updateLink>>
>;
export type ExportLinksCsvResult = NonNullable<
  Awaited<ReturnType<typeof exportLinksCsv>>
>;
export type CreateMultipleLinksResult = NonNullable<
  Awaited<ReturnType<typeof createMultipleLinks>>
>;
export type BatchUpdateLinksResult = NonNullable<
  Awaited<ReturnType<typeof batchUpdateLinks>>
>;
export type DeleteLinksResult = NonNullable<
  Awaited<ReturnType<typeof deleteLinks>>
>;
export type ValidateLinkPasswordResult = NonNullable<
  Awaited<ReturnType<typeof validateLinkPassword>>
>;
export type GetMetadataFromUrlResult = NonNullable<
  Awaited<ReturnType<typeof getMetadataFromUrl>>
>;
